<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'

// Titled block used by every section of the detail page — the Gray/500
// uppercase heading ("AMENITIES", "SUPPORT", …) sits 14px above the content
// (20px on Investment Highlights / Location & Landmark, per Figma).
interface Props {
  title: string
  /** Heading → content spacing. */
  gap?: string
}

withDefaults(defineProps<Props>(), { gap: '14px' })
</script>

<template>
  <Box is="section" direction="col" :gap="gap" class="pd-section">
    <Text
      type="heading"
      weight="semibold"
      color="var(--p-surface-500)"
      transform="uppercase"
      is="h2"
      class="pd-section__title"
    >
      {{ title }}
    </Text>
    <slot />
  </Box>
</template>

<style scoped>
.pd-section {
  min-width: 0;
}

.pd-section__title {
  line-height: 24px;
}
</style>
